(function () {
  // Fallback specs (criterii de bază) dacă produsele nu au spec_table.
  var BASIC = [
    { label: 'BTU', key: 'btu', suffix: ' BTU' },
    { label: 'Coverage', key: 'roomSize' },
    { label: 'Zones', key: 'zones' },
    { label: 'Voltage', key: 'voltage' },
    { label: 'Series', key: 'series' },
    { label: 'Installation', key: 'install' }
  ];

  function specVal(p, label) {
    var t = p.specTable || [];
    for (var i = 0; i < t.length; i++) { if (t[i].label === label) return t[i].value; }
    return null;
  }
  function basicVal(p, key) {
    var v = p[key];
    if (Array.isArray(v)) v = v.join(', ');
    return (v == null || v === '') ? null : String(v);
  }
  function unionLabels(chosen) {
    var labels = [];
    chosen.forEach(function (p) {
      (p.specTable || []).forEach(function (r) { if (r && r.label && labels.indexOf(r.label) === -1) labels.push(r.label); });
    });
    return labels;
  }
  function cell(v) {
    return v == null
      ? '<span class="cmp__cell-val cmp__cell-val--empty">—</span>'
      : '<span class="cmp__cell-val">' + v + '</span>';
  }

  // Card-ul de header al unui produs (badge, imagine, titlu, preț).
  function headHTML(p, idx) {
    var badge = idx === 0
      ? '<span class="cmp__badge">Best Match</span>'
      : '<span class="cmp__badge cmp__badge--value">Great Value</span>';
    var img = p.image ? '<img src="' + p.image + '" alt="' + (p.title || '') + '" loading="lazy">' : '';
    return '<div class="cmp__head' + (idx === 0 ? ' cmp__head--best' : '') + '">' + badge +
      '<div class="cmp__media">' + img + '</div>' +
      '<h3 class="cmp__name">' + p.title + '</h3>' +
      '<div class="cmp__price">' + (p.price || '') + '</div>' +
    '</div>';
  }
  // Footer-ul (Add to cart + View) al unui produs.
  function footHTML(p) {
    var add = p.available
      ? '<product-form class="cmp__addwrap" data-hide-errors="true">' +
          '<div class="product-form__error-message-wrapper" role="alert" hidden><span class="product-form__error-message"></span></div>' +
          '<form action="/cart/add" method="post" enctype="multipart/form-data" class="cmp__addform" data-type="add-to-cart-form" novalidate>' +
            '<input type="hidden" name="id" value="' + p.variantId + '">' +
            '<button type="submit" name="add" class="cmp__add">Add to cart</button>' +
          '</form>' +
        '</product-form>'
      : '<span class="cmp__add cmp__add--soldout">Sold out</span>';
    return '<div class="cmp__foot">' + add +
      '<a class="cmp__view" href="' + p.url + '">View full details &rarr;</a>' +
    '</div>';
  }
  // Un rând de spec: label + o celulă per produs (aliniate în același grid).
  function rowHTML(r) {
    var cells = r.values.map(function (v) { return '<div class="cmp__cell">' + cell(v) + '</div>'; }).join('');
    return '<div class="cmp__row' + (r.diff ? ' is-diff' : '') + '">' +
      '<div class="cmp__rowlabel">' + r.label + '</div>' +
      '<div class="cmp__rowvals">' + cells + '</div>' +
    '</div>';
  }

  function buildRows(chosen) {
    var labels = unionLabels(chosen);
    var useBasic = labels.length === 0;
    var src = useBasic ? BASIC.map(function (b) { return b.label; }) : labels;
    return src.map(function (label, i) {
      var values = chosen.map(function (p) {
        if (useBasic) { var b = BASIC[i]; var v = basicVal(p, b.key); return v == null ? null : v + (b.suffix || ''); }
        return specVal(p, label);
      });
      var seen = {}, distinct = 0;
      values.forEach(function (v) { var k = v == null ? '' : v; if (!(k in seen)) { seen[k] = 1; distinct++; } });
      return { label: label, values: values, diff: distinct > 1 };
    });
  }

  function init(root) {
    if (root.dataset.cmpReady) return;
    root.dataset.cmpReady = '1';
    var all = [];
    try { all = JSON.parse(root.querySelector('[data-cmp-products]').textContent); } catch (e) {}
    var table = root.querySelector('[data-cmp-table]');
    var empty = root.querySelector('[data-cmp-empty]');
    var toggle = root.querySelector('[data-cmp-difftoggle]');
    var params = new URLSearchParams(window.location.search);
    var handles = (params.get('products') || '').split(',').map(function (h) { return h.trim(); }).filter(Boolean);
    var chosen = handles.map(function (h) {
      for (var i = 0; i < all.length; i++) { if (all[i].handle === h) return all[i]; }
      return null;
    }).filter(Boolean);

    if (!chosen.length) {
      table.hidden = true;
      var w0 = toggle && (toggle.closest('.cmp__diff') || toggle);
      if (w0) w0.hidden = true;
      if (empty) empty.hidden = false;
      return;
    }

    var rows = buildRows(chosen);
    table.style.setProperty('--cmp-cols', chosen.length);
    table.innerHTML =
      '<div class="cmp__heads">' + chosen.map(headHTML).join('') + '</div>' +
      '<div class="cmp__rows">' + rows.map(rowHTML).join('') + '</div>' +
      '<div class="cmp__foots">' + chosen.map(footHTML).join('') + '</div>';
    table.hidden = false;
    if (empty) empty.hidden = true;

    var hasDiff = rows.some(function (r) { return r.diff; });
    if (toggle) {
      var wrap = toggle.closest('.cmp__diff') || toggle;
      if (hasDiff && chosen.length > 1) {
        wrap.hidden = false;
        toggle.addEventListener('change', function () {
          root.classList.toggle('cmp--diffonly', toggle.checked);
        });
      } else {
        wrap.hidden = true;
      }
    }
  }
  function boot() { document.querySelectorAll('.cmp').forEach(init); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
